// src/services/await-all-safely.ts
async function awaitAllSafely(...promises) {
  try {
    return await Promise.all(promises);
  } catch (error) {
    await Promise.allSettled(promises);
    throw error;
  }
}
export {
  awaitAllSafely
};
